import { Inject, Injectable } from '@angular/core'
import { UserContextStorageService } from '../auth/user-context/user-context-storage.service'
import _ from 'lodash'

@Injectable({
    providedIn: 'root',
})
export class MapLayerSettingsStorageService {

    constructor(
        @Inject(UserContextStorageService) private userContextStorageService: any
    ) {
    }

    /**
     * Returns mapLayerSettings for given key and subKey
     * @returns {undefined|Object}
     */
    public getSavedSettings(key: string, subKey: string): any {
        const current = JSON.parse(localStorage.getItem(this.getStoragePrefix('mapLayerSettings'))) || {}

        if (!current[key]) {
            return null
        }

        return current[key][subKey]
    }

    /**
     * Get object of all mapLayerSettings
     * @returns {{}}
     */
    public getAllSavedSettings(): any {
        return JSON.parse(localStorage.getItem(this.getStoragePrefix('mapLayerSettings'))) || {}
    }

    /**
     * Removes entire mapLayerSettings for given key
     * @param key
     */
    public removeSavedSettings(key: string): void {
        const current = JSON.parse(localStorage.getItem(this.getStoragePrefix('mapLayerSettings'))) || {}
        delete current[key]
        localStorage.setItem(this.getStoragePrefix('mapLayerSettings'), JSON.stringify(current))

    }

    /**
     * Sets mapLayerSettings for given key and subKey
     * @param key
     * @param subKey
     * @param data
     */
    public setSavedSettings(key: string, subKey: string, data: any): void {
        let current = JSON.parse(localStorage.getItem(this.getStoragePrefix('mapLayerSettings'))) || {}
        if (!current || !_.isObject(current)) {
            current = {}
        }
        if (!current[key]) {
            current[key] = {}
        }
        current[key][subKey] = data
        localStorage.setItem(this.getStoragePrefix('mapLayerSettings'), JSON.stringify(current))
    }


    /************************************************************************/

    /**
     * Returns unique key (with project key) for saving position or zoom.
     * @param {String} key
     * @returns {String}
     */
    private getStoragePrefix(key: string): string {
        const project = this.userContextStorageService.getProject()

        return project.key + '-settings-' + key
    }
}
